<template>
  <FinderResultLayout
    v-bind="props"
    result-type="provider"
    :labels="labels"
    :thumbnail="thumbnail"
    v-on="forwardedEvents"
  >
    <template #thumbnail-overlay="{ displayName }">
      <FinderResultVideo
        v-if="result.video_url"
        class="sp-finder-result__video"
        :name="displayName"
        :url="result.url"
        :video-url="result.video_url"
        @play-video="handlePlayVideo"
      />
    </template>
    <template #thumbnail-details>
      <FinderResultBadges :badge="result.badge" :independent-badge-text="result.independent_badge_text" />
    </template>
  </FinderResultLayout>
</template>

<script setup>
import { computed } from "vue";
import { createFinderResultListeners } from "#ce/components/SpFinder/event-listeners/finder-result-listeners";
import { useFinderResultLabels } from "./composables/useFinderResultLabels";
import FinderResultBadges from "./components/FinderResultBadges.ce.vue";
import FinderResultLayout from "./components/FinderResultLayout.ce.vue";
import FinderResultVideo from "./components/FinderResultVideo.ce.vue";
import { props as propsDefinitions } from "./props/finder-result.js";
import { props as providerPropsDefinitions } from "./props/provider-result.js";

const props = defineProps({ ...propsDefinitions, ...providerPropsDefinitions });

const emit = defineEmits([
  "add-filters",
  "show-map",
  "play-video",
  "show-more-slots",
  "show-date",
  "toggle-other-locations",
  "retry-other-locations",
]);

const forwardedEvents = createFinderResultListeners(emit);
const labels = useFinderResultLabels(() => props.labels);

const thumbnail = computed(() => ({
  imageUrl: props.result.image_url,
  badge: props.result.badge,
  independentBadgeText: props.result.independent_badge_text,
  awards: props.result.awards || [],
}));

function handlePlayVideo(payload) {
  emit("play-video", payload);
}
</script>

<style lang="scss" scoped>
.sp-finder-result__video {
  position: absolute;
  right: 0;
  bottom: -10%;
  width: 33%;
  height: 33%;
}
</style>
